<div class="pages-campaign-container">
  <div class="page-campaign-content">
    <div class="page-campaign-content-header">
      <div class="left-side"></div>
      <div class="right-side">Support US!</div>
    </div>
    <div class="page-campaign-content-body">
      <p-stepper [(value)]="active">
        <p-step-list>
          <p-step [value]="1">
            <ng-template #content let-activateCallback="activateCallback" let-value="value" let-index="index">
              <p-button class="bg-transparent border-none inline-flex flex-column gap-2 pointer" (click)="activateCallback()" pTooltip="Contact Info"
                      [ngClass]="{'active': index <= active,'surface-border': index > active}">
                      <span class="border-round border-2 w-3rem h-3rem inline-flex align-items-center justify-content-center">
                          <i class="pi pi-user"></i>
                      </span>
              </p-button>
            </ng-template>
          </p-step>
          <p-step [value]="2">
            <ng-template #content let-activateCallback="activateCallback" let-value="value" let-index="index">
              @if(stepOneComplete) {
                <p-button class="bg-transparent border-none inline-flex flex-column gap-2 pointer" (click)="activateCallback()" pTooltip="Billing"
                        [ngClass]="{'active': index <= active,'surface-border': index > active}">
                      <span class="border-round border-2 w-3rem h-3rem inline-flex align-items-center justify-content-center">
                          <i class="pi pi-credit-card"></i>
                      </span>
                </p-button>
              } @else {
                <p-button class="bg-transparent border-none inline-flex flex-column gap-2 pointer" pTooltip="Billing"
                        [ngClass]="{'active': index <= active,'surface-border': index > active}">
                      <span class="border-round border-2 w-3rem h-3rem inline-flex align-items-center justify-content-center">
                          <i class="pi pi-credit-card"></i>
                      </span>
                </p-button>
              }

            </ng-template>
          </p-step>
          <p-step [value]="3">
            <ng-template #content let-activateCallback="activateCallback" let-value="value" let-index="index">
              @if(stepTwoComplete) {
                <p-button class="bg-transparent border-none inline-flex flex-column gap-2 pointer" (click)="activateCallback()" pTooltip="Address"
                        [ngClass]="{
                                'active': index <= active,
                                'surface-border': index > active
                            }" >
                        <span class="border-round border-2 w-3rem h-3rem inline-flex align-items-center justify-content-center">
                            <i class="pi pi-id-card"></i>
                        </span>
                </p-button>
              } @else {
                <p-button class="bg-transparent border-none inline-flex flex-column gap-2 pointer" pTooltip="Address"
                        [ngClass]="{
                                'active': index <= active,
                                'surface-border': index > active
                            }" >
                        <span class="border-round border-2 w-3rem h-3rem inline-flex align-items-center justify-content-center">
                            <i class="pi pi-id-card"></i>
                        </span>
                </p-button>
              }
            </ng-template>
          </p-step>
          <p-step [value]="4">
            <ng-template #content let-activateCallback="activateCallback" let-value="value" let-index="index">
              <p-button class="bg-transparent border-none inline-flex flex-column gap-2 pointer" pTooltip="Complete"
                      [ngClass]="{
                              'active': index <= active,
                              'surface-border': index > active
                          }">
                      <span class="border-round border-2 w-3rem h-3rem inline-flex align-items-center justify-content-center">
                          <i class="pi pi-check"></i>
                      </span>
              </p-button>
            </ng-template>
          </p-step>
        </p-step-list>
        <p-step-panels>
          <p-step-panel [value]="1">
            <ng-template #content let-activateCallback="activateCallback">
              <app-campaign-page-1 (next)="activateCallback(2); stepOneComplete=true" [campaignProfile]="campaignProfile" [orgCampaignDetails]="orgCampaignDetails"
                                   (updateData)="campaignProfile = $event" ></app-campaign-page-1>
            </ng-template>
          </p-step-panel>
          <p-step-panel [value]="2">
            <ng-template #content let-activateCallback="activateCallback">
              <app-campaign-page-2 (next)="activateCallback(3);  stepTwoComplete =true" [campaignProfile]="campaignProfile" [orgCampaignDetails]="orgCampaignDetails"
                                   (updateData)="campaignProfile = $event" ></app-campaign-page-2>
            </ng-template>
          </p-step-panel>
          <p-step-panel [value]="3">
            <ng-template #content let-activateCallback="activateCallback">
              <app-campaign-page-3 (next)="activateCallback(4); stepThreeComplete = true" (updateData)="campaignProfile = $event" [campaignProfile]="campaignProfile"
                                   [orgCampaignDetails]="orgCampaignDetails"></app-campaign-page-3>
            </ng-template>
          </p-step-panel>
          <p-step-panel [value]="4">
            <ng-template #content let-activateCallback="activateCallback">
              <app-campaign-page-4  [campaignProfile]="campaignProfile"  [orgCampaignDetails]="orgCampaignDetails"></app-campaign-page-4>
            </ng-template>
          </p-step-panel>
        </p-step-panels>
      </p-stepper>







<!--        <p-stepperPanel header="Contact Info">-->
<!--          <ng-template #header let-onClick="onClick" let-index="index">-->
<!--            <p-button class="bg-transparent border-none inline-flex flex-column gap-2 pointer" (click)="onClick.emit()" pTooltip="Contact Info"-->
<!--                    [ngClass]="{'active': index <= active,'surface-border': index > active}">-->
<!--                      <span class="border-round border-2 w-3rem h-3rem inline-flex align-items-center justify-content-center">-->
<!--                          <i class="pi pi-user"></i>-->
<!--                      </span>-->
<!--            </p-button>-->
<!--          </ng-template>-->
<!--          <ng-template pTemplate="content" let-nextCallback="nextCallback">-->
<!--                  <app-campaign-page-1 (next)="nextCallback.emit(); stepOneComplete = true" [campaignProfile]="campaignProfile" [orgCampaignDetails]="orgCampaignDetails"-->
<!--                                       (updateData)="campaignProfile = $event" ></app-campaign-page-1>-->
<!--          </ng-template>-->
<!--        </p-stepperPanel>-->
<!--        <p-stepperPanel>-->
<!--          <ng-template #header let-onClick="onClick" let-index="index">-->
<!--            @if(stepOneComplete) {-->
<!--              <p-button class="bg-transparent border-none inline-flex flex-column gap-2 pointer" (click)="onClick.emit()" pTooltip="Billing"-->
<!--                      [ngClass]="{'active': index <= active,'surface-border': index > active}">-->
<!--                      <span class="border-round border-2 w-3rem h-3rem inline-flex align-items-center justify-content-center">-->
<!--                          <i class="pi pi-credit-card"></i>-->
<!--                      </span>-->
<!--              </p-button>-->
<!--            } @else {-->
<!--              <p-button class="bg-transparent border-none inline-flex flex-column gap-2 pointer" pTooltip="Billing"-->
<!--                      [ngClass]="{'active': index <= active,'surface-border': index > active}">-->
<!--                      <span class="border-round border-2 w-3rem h-3rem inline-flex align-items-center justify-content-center">-->
<!--                          <i class="pi pi-credit-card"></i>-->
<!--                      </span>-->
<!--              </p-button>-->
<!--            }-->

<!--          </ng-template>-->
<!--          <ng-template pTemplate="content" let-nextCallback="nextCallback">-->
<!--            <app-campaign-page-2 (next)="nextCallback.emit(); stepTwoComplete = true " [campaignProfile]="campaignProfile" [orgCampaignDetails]="orgCampaignDetails"-->
<!--                                 (updateData)="campaignProfile = $event" ></app-campaign-page-2>-->
<!--          </ng-template>-->
<!--        </p-stepperPanel>-->
<!--        <p-stepperPanel header="Contact Info">-->
<!--          <ng-template #header let-onClick="onClick" let-index="index">-->
<!--            @if(stepTwoComplete) {-->
<!--              <p-button class="bg-transparent border-none inline-flex flex-column gap-2 pointer" (click)="onClick.emit()" pTooltip="Address"-->
<!--                      [ngClass]="{-->
<!--                                'active': index <= active,-->
<!--                                'surface-border': index > active-->
<!--                            }" >-->
<!--                        <span class="border-round border-2 w-3rem h-3rem inline-flex align-items-center justify-content-center">-->
<!--                            <i class="pi pi-id-card"></i>-->
<!--                        </span>-->
<!--              </p-button>-->
<!--            } @else {-->
<!--              <p-button class="bg-transparent border-none inline-flex flex-column gap-2 pointer" pTooltip="Address"-->
<!--                      [ngClass]="{-->
<!--                                'active': index <= active,-->
<!--                                'surface-border': index > active-->
<!--                            }" >-->
<!--                        <span class="border-round border-2 w-3rem h-3rem inline-flex align-items-center justify-content-center">-->
<!--                            <i class="pi pi-id-card"></i>-->
<!--                        </span>-->
<!--              </p-button>-->
<!--            }-->
<!--          </ng-template>-->
<!--          <ng-template pTemplate="content" let-nextCallback="nextCallback">-->
<!--            <app-campaign-page-3 (next)="nextCallback.emit(); stepThreeComplete = true " (updateData)="campaignProfile = $event" [campaignProfile]="campaignProfile"-->
<!--                                 [orgCampaignDetails]="orgCampaignDetails"></app-campaign-page-3>-->
<!--          </ng-template>-->
<!--        </p-stepperPanel>-->
<!--        <p-stepperPanel header="Contact Info">-->
<!--          <ng-template #header let-onClick="onClick" let-index="index">-->
<!--            <p-button class="bg-transparent border-none inline-flex flex-column gap-2 pointer" pTooltip="Complete"-->
<!--                    [ngClass]="{-->
<!--                              'active': index <= active,-->
<!--                              'surface-border': index > active-->
<!--                          }">-->
<!--                      <span class="border-round border-2 w-3rem h-3rem inline-flex align-items-center justify-content-center">-->
<!--                          <i class="pi pi-check"></i>-->
<!--                      </span>-->
<!--            </p-button>-->
<!--          </ng-template>-->
<!--          <ng-template pTemplate="content" let-nextCallback="nextCallback">-->
<!--            <app-campaign-page-4 (next)="nextCallback.emit()" [campaignProfile]="campaignProfile"  [orgCampaignDetails]="orgCampaignDetails"></app-campaign-page-4>-->
<!--          </ng-template>-->
<!--        </p-stepperPanel>-->
<!--      </p-stepper>-->
    </div>
  </div>
</div>


<!--Primeng 18 way for future-->
<!--<p-stepper [value]="1" class="basis-[50rem]" [linear]="true">-->
<!--  <p-step-list>-->
<!--    <p-step [value]="1">Contact Info</p-step>-->
<!--    <p-step [value]="2">Header II</p-step>-->
<!--    <p-step [value]="3">Header II</p-step>-->
<!--  </p-step-list>-->
<!--  <p-step-panels>-->
<!--  </p-step-panels>-->
<!--</p-stepper>-->
